import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/services/shared/auth.service';
import { AdminService } from 'src/app/services/admin/admin.service';
import { DeliveryPlatformService } from 'src/app/services/delivery/delivery-platform.service';
import { UserService } from 'src/app/services/user/user.service';

declare var $: any;

@Component({
  selector: 'app-account-info',
  templateUrl: './account-info.component.html',
  styleUrls: ['./account-info.component.scss'],
})
export class AccountInfoComponent implements OnInit {
  loggedUserRole: any;
  user: any;
  outlet: any;
  loading = false;
  dpLoading = false;
  submitted = false;
  dpSubmitted = false;
  isSuccess = false;
  isDpSuccess = false;
  brandLoading = false;
  isSuccessBrand = false;
  submittedBrand = false;
  brandMessage = '';
  message = '';
  dpMessage = '';
  dpCredentials: any;
  fileTypes = ["image/png", "image/jpeg"];
  logoFile: any;
  logoHeader: any = 'BrandLogo.png';
  logoURL: any = '';
  logoFileError: string;
  commonBrandData: any;
  hasGoogleReservation: any;

  constructor(
    private userService: UserService,
    private authService: AuthenticationService,
    private deliveryService: DeliveryPlatformService,
    private adminService: AdminService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.getCurrentUser();
    this.getPlatformId();
    this.getCommonBrands();

    $('.selectpicker').selectpicker('refresh');
  }

  form: FormGroup = new FormGroup({
    first_name: new FormControl('', [Validators.required]),
    last_name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });
  formTwo: FormGroup = new FormGroup({
    outlet_name: new FormControl('', [Validators.required]),
    outlet_code: new FormControl('', [Validators.required]),
  });

  dpCredentialForm: FormGroup = new FormGroup({
    delivery_platform_id: new FormControl('', [Validators.required]),
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  get f() {
    return this.form.controls;
  }

  commonBrandForm: FormGroup = new FormGroup({
    common_logo: new FormControl('', [Validators.required]),
    common_brand_name: new FormControl('', [Validators.required]),
    has_google_reservation: new FormControl(''),
    google_reservation_username: new FormControl(''),
  });

  get brandF() {
    return this.commonBrandForm.controls;
  }

  getCurrentUser() {
    this.userService.getCurrentUser().subscribe((res) => {

      this.user = res.data;
      this.outlet = res.data.shops;
      this.form.controls['first_name'].setValue(this.user.name);
      this.form.controls['last_name'].setValue(this.user.last_name);
      this.form.controls['email'].setValue(this.user.email);

      this.authService.storeUser(res.data);
      this.loggedUserRole = this.authService.getLoggedUser().user_roles.role_id;

      if (this.loggedUserRole > 2) {
        $('#spicker_shop_auto_accept').removeAttr('disabled');
        $('#spicker_shop_auto_accept').selectpicker('refresh');
        $('#spicker_shop_auto_accept').selectpicker('val', '');
      }

      // if a outlet admin set formTwo values
      if (this.loggedUserRole === 4 && this.outlet.length > 0) {
        for (let data of this.outlet) {
          this.formTwo.controls['outlet_name'].setValue(data.name);
          this.formTwo.controls['outlet_code'].setValue(data.code);
        }
      }
    });
  }

  getPlatformId() {
    this.deliveryService
      .getPlatforms()
      .subscribe({
        next: (res) => {
          console.log(res);
          for (const value of res.data) {
            if (value.name === 'DELIVEROO') {
              this.dpCredentialForm.patchValue({
                delivery_platform_id: value.id,
              });
              this.deliveryService.getDpCredentials(value.id).subscribe((res) => {
                console.log(res.data, 'getDpCredentials');
                this.dpCredentials = res.data;

                this.dpCredentialForm.patchValue({
                  username: res.data.username,
                });
              });
            }
          }
        },
        error: (error) => {
          console.log(error, 'Error');
        }
      });
  }

  getCommonBrands() {
    this.adminService.getCommonBrandDetails()
      .subscribe({
        next: (res) => {
          console.log(res.data, "getCommonBrands");
          this.commonBrandData = res.data
          this.commonBrandForm.patchValue(res.data)
          this.hasGoogleReservation = res.data.has_google_reservation == 1 ? true : false;
        },
        error: (error) => { }

      })
  }

  updatePassword() {
    this.loading = true;
    this.submitted = true;
    if (this.form.invalid) {
      this.form.setErrors({
        invalidLogin: true,
      });
      this.message = 'Please fill all required fields!';
      this.loading = false;
    } else {
      this.userService
        .updatePassword(this.user.id, this.form.value.password)
        .subscribe({
          next: (res) => {
            this.isSuccess = true;
            this.message = 'Successfully updated the password!';
            this.loading = false;
          },
          error: (error) => {
            console.log(error, 'Error');
            this.isSuccess = false;
            this.message = 'The password must be at least 6 characters.';
            this.loading = false;
          }
        });
    }
  }

  saveCredentials() {
    this.dpLoading = true;
    this.dpSubmitted = true;
    const formData = new FormData();
    console.log(this.dpCredentials, this.dpCredentials?.id, 'getDpCredentials');
    formData.append(
      'platform_id',
      this.dpCredentialForm.value['delivery_platform_id']
    );
    formData.append('username', this.dpCredentialForm.value['username']);
    formData.append('password', this.dpCredentialForm.value['password']);

    console.log(formData.getAll('delivery_platform_id'), 'DP FORM');

    if (this.dpCredentialForm.invalid) {
      this.dpCredentialForm.setErrors({
        invalidLogin: true,
      });
      this.dpMessage = 'Please fill all required fields!';
      this.dpLoading = false;
    } else {
      if (this.dpCredentials) {
        formData.append('_method', 'PUT');
        this.deliveryService
          .updateDpCredentials(this.dpCredentials.id, formData)
          .subscribe({
            next: (res) => {
              console.log(res);
              this.isDpSuccess = true;
              this.dpMessage = 'Successfully updated Deliveroo Credentials!';
              this.dpLoading = false;
            },
            error: (error) => {
              this.isDpSuccess = false;
              this.dpMessage = error;
              this.dpLoading = false;
            }
          });
      } else {
        this.deliveryService
          .createDpCredentials(formData)
          .subscribe({
            next: (res) => {
              console.log(res);
              this.isDpSuccess = true;
              this.dpMessage = 'Successfully created delivery platform credentials!';
              this.dpLoading = false;
            },
            error: (error) => {
              console.log(error, 'Error');
              this.isDpSuccess = false;
              this.dpMessage = error;
              this.dpLoading = false;
            }
          });
      }
    }
  }

  setBrandLogo(e: any) {
    console.log(e.target.files[0], "setBrandLogo");
    let selected = e.target.files[0];
    if (selected && this.fileTypes.includes(selected.type)) {
      this.logoFile = selected

      var reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = (_event) => {
        this.logoURL = reader.result;
        this.commonBrandForm.patchValue({
          common_logo: selected.name,

        })
      }

    }
  }

  updateSwitch(event: any) {
    this.hasGoogleReservation = event
    let value = event ? 1 : 0;
    this.commonBrandForm.patchValue({
      has_google_reservation: value
    })
    if (value == 1) {
      this.commonBrandForm.controls.google_reservation_username.setValidators([Validators.required])
      this.commonBrandForm.controls.google_reservation_username.updateValueAndValidity()
    }

  }

  saveBrandDetails() {
    this.brandLoading = true;
    this.submittedBrand = true;
    let brandLOGO = this.logoFile ? this.logoFile : this.commonBrandForm.value.common_logo;
    const formData = new FormData();
    formData.append('common_logo', brandLOGO);
    formData.append('common_brand_name', this.commonBrandForm.value.common_brand_name);
    formData.append('has_google_reservation', this.commonBrandForm.value.has_google_reservation);
    formData.append('google_reservation_username', this.commonBrandForm.value.google_reservation_username);
    formData.append('_method', 'PUT');
    if (this.commonBrandForm.invalid) {
      console.log(this.commonBrandForm);

      this.commonBrandForm.setErrors({
        invalidLogin: true,
      });
      this.brandMessage = 'Please fill all required fields!';
      this.brandLoading = false;
    } else {
      this.adminService
        .updateCommonBrandDetails(this.commonBrandData.id, formData)
        .subscribe({
          next: (res) => {
            console.log(res);
            this.isSuccessBrand = true;
            this.brandMessage = 'Successfully updated common brand details!';
            this.brandLoading = false;
          },
          error: (error) => {
            this.isSuccessBrand = false;
            this.brandMessage = error;
            this.brandLoading = false;
          }
        });
    }
  }

  restValidation() {
    this.message = '';
    this.isSuccess = false;
    this.submitted = false;
    this.loading = false;
    this.dpMessage = '';
    this.isDpSuccess = false;
    this.dpSubmitted = false;
    this.dpLoading = false;
    this.isSuccessBrand = false;
    this.submittedBrand = false;
  }
}
